/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Vrátit mou objednávku`
};

const da_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Returnér min ordre`
};

const de_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung zurückgeben`
};

const en_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Return my order`
};

const es_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Devolver mi pedido`
};

const fr_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Retourner ma commande`
};

const hu_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelésem visszaküldése`
};

const it_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Restituisci il mio ordine`
};

const nl_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelling retourneren`
};

const pl_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Zwróć zamówienie`
};

const pt_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Devolver meu pedido`
};

const sv_footer_services_return_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Returnera min beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const footer_services_return_my_order = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_services_return_my_order(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_services_return_my_order", locale)
	if (locale === "cs") return cs_footer_services_return_my_order(inputs)
	if (locale === "da") return da_footer_services_return_my_order(inputs)
	if (locale === "de") return de_footer_services_return_my_order(inputs)
	if (locale === "en") return en_footer_services_return_my_order(inputs)
	if (locale === "es") return es_footer_services_return_my_order(inputs)
	if (locale === "fr") return fr_footer_services_return_my_order(inputs)
	if (locale === "hu") return hu_footer_services_return_my_order(inputs)
	if (locale === "it") return it_footer_services_return_my_order(inputs)
	if (locale === "nl") return nl_footer_services_return_my_order(inputs)
	if (locale === "pl") return pl_footer_services_return_my_order(inputs)
	if (locale === "pt") return pt_footer_services_return_my_order(inputs)
	return sv_footer_services_return_my_order(inputs)
};
export { footer_services_return_my_order as "footer.services.return_my_order" }